export default "__VITE_ASSET__48fb8b72__"